import script from "./UReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./UReview.vue?vue&type=script&setup=true&lang=ts"

import "./UReview.vue?vue&type=style&index=0&id=16e790a3&lang=css"

const __exports__ = script;

export default __exports__